<template>
  <div class="swal-alert"></div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "OverlayLoading",

  data() {
    return {
      percent: 0,
      show: false,
      isSuccess: true,
      duration: 3000,
      successColor: "#0a84ff",
      failedColor: "#ff3b30",
    };
  },

  methods: {
    start() {
      Swal.fire({
        title: "Sedang memproses...",
        html: `
      <div style="width:100%; background:#e6f0ff; border-radius:10px; overflow:hidden; height:10px; margin-top:12px;">
        <div id="progress-bar" style="width:0%; height:100%; background:linear-gradient(90deg,#007aff,#00b7ff); border-radius:10px; transition:width 0.25s;"></div>
      </div>
      <div id="progress-text" style="margin-top:8px; font-size:14px; font-weight:600; color:#007aff;">0%</div>
    `,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        background: "#ffffff",
        color: "#1a1a1a",
        didOpen: () => {
          this.percent = 0;
          const bar = Swal.getHtmlContainer().querySelector("#progress-bar");
          const text = Swal.getHtmlContainer().querySelector("#progress-text");

          this._cut = 10000 / Math.floor(this.duration);
          this._timer = setInterval(() => {
            this.percent = Math.min(
              this.percent + Math.floor(this._cut * Math.random()),
              100
            );
            bar.style.width = this.percent + "%";
            text.textContent = Math.floor(this.percent) + "%";

            if (this.percent >= 100) {
              clearInterval(this._timer);
              this._timer = null;
              // beri delay agar 100% terlihat
              setTimeout(() => this.finish(), 600); // 600ms delay
            }
          }, 100);
        },
      });
    },
    increase(num) {
      this.percent = Math.min(this.percent + Math.floor(num), 100);
      return this;
    },

    finish() {
      clearInterval(this._timer);
      this._timer = null;

      const container = Swal.getHtmlContainer();
      if (!container) return;

      const bar = container.querySelector("#progress-bar");
      const text = container.querySelector("#progress-text");

      if (bar) {
        bar.style.width = "100%"; // pastikan penuh
        bar.classList.add("done"); // ubah style jika perlu
      }

      if (text) {
        text.textContent = "Selesai!"; // ubah teks di bawah progress bar
        text.style.color = "#0a84ff";
        text.style.fontWeight = "600";
      }

      // Ganti title SweetAlert tanpa menghilangkan HTML
      Swal.update({
        title: "Selesai!",
        html: container.innerHTML, // penting: biarkan HTML progress bar tetap ada
      });

      // Tutup beberapa saat setelah selesai
      setTimeout(() => Swal.close(), 800);
    },

    fail() {
      clearInterval(this._timer);
      this.isSuccess = false;
      this.percent = 100;
      Swal.fire({
        title: "Gagal!",
        text: "Terdapat data yang tidak valid",
        icon: "error",
        confirmButtonText: "Coba Lagi",
        background: "#ffffff",
        color: "#1a1a1a",
        customClass: {
          confirmButton: "btn btn-primary order-2",
        },
      });
    },

    submit() {
      clearInterval(this._timer);
      this._timer = null;

      const container = Swal.getHtmlContainer();
      if (!container) return;

      const bar = container.querySelector("#progress-bar");
      const text = container.querySelector("#progress-text");

      if (bar) {
        bar.style.width = "100%";
        bar.classList.add("done");
      }

      if (text) {
        text.textContent = "Data berhasil disimpan!";
        text.style.color = "#0a84ff";
        text.style.fontWeight = "600";
      }

      Swal.update({
        title: "Berhasil!",
        html: container.innerHTML, // penting: biarkan HTML progress bar tetap ada
      });

      setTimeout(() => Swal.close(), 800);
    },
  },
};
</script>

<style scoped>
.loading-popup {
  border-radius: 16px !important;
  box-shadow: 0 0 20px rgba(0, 122, 255, 0.2);
  padding: 20px 30px !important;
}

.loading-title {
  font-weight: 600 !important;
  font-size: 18px !important;
}

.progress-container {
  width: 100%;
  height: 10px;
  background: #e6f0ff;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  margin-top: 12px;
}

.progress-bar {
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, #007aff, #00b7ff);
  border-radius: 10px;
  transition: width 0.25s ease;
  box-shadow: 0 0 10px rgba(0, 122, 255, 0.4);
  animation: glowBlue 2s infinite alternate;
}

.progress-text {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #007aff;
}

@keyframes glowBlue {
  from {
    box-shadow: 0 0 6px rgba(0, 122, 255, 0.3);
  }
  to {
    box-shadow: 0 0 18px rgba(0, 122, 255, 0.7);
  }
}

.progress-container.done .progress-bar {
  background: linear-gradient(90deg, #0a84ff, #5ac8fa);
}
</style>
